import { render, staticRenderFns } from "./AntifraudActivePoints.vue?vue&type=template&id=5e3336d8&"
import script from "./AntifraudActivePoints.vue?vue&type=script&lang=js&"
export * from "./AntifraudActivePoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports